import CryptoJS from "crypto-js";

export function decryptData(encryptedData, key) {
  const [ivHex, encryptedBase64] = encryptedData.split(":");
  const iv = CryptoJS.enc.Hex.parse(ivHex);

  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: CryptoJS.enc.Base64.parse(encryptedBase64) },
    CryptoJS.enc.Utf8.parse(key),
    { iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 }
  );

  return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
}

